import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { ConfirmationPageSettingsFragment } from "__generated__/graphql";

interface IConfirmationPageProps {
  confirmationPageSettings: ConfirmationPageSettingsFragment | null;
}
export const ConfirmationPage: React.FC<IConfirmationPageProps> = ({
  confirmationPageSettings,
}) => {
  useEffect(() => {
    setTimeout(() => {
      if (confirmationPageSettings?.redirectUrl) {
        const isIframe = window.top !== window.self;
        if (isIframe && window.top) {
          window.top.location.href = confirmationPageSettings.redirectUrl;
        } else {
          window.location.replace(confirmationPageSettings.redirectUrl);
        }
      }
    }, 1000);
  });
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: (theme) => theme.palette.background.lightBlue,
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          background: (theme) => theme.palette.common.white,
          p: 4,
        }}
      >
        <Typography variant="h4">
          {confirmationPageSettings?.thankYouHeader || "Thank you"}
        </Typography>
        <Typography mt={2}>
          {confirmationPageSettings?.thankYouMessage ||
            "Thank you for submitting the form. Your information has been successfully received."}
        </Typography>
        {confirmationPageSettings?.redirectUrl && (
          <Typography mt={4}>
            You are being redirected to{" "}
            <a href={confirmationPageSettings.redirectUrl}>
              {confirmationPageSettings.redirectUrl}
            </a>
            .
          </Typography>
        )}
        <Box
          sx={{
            mt: 4,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" color="grey.900">
            This form was created using Nexl . Explore{" "}
            <a href="https://nexl.cloud/">Nexl</a> to learn more.
          </Typography>
          <img height={16} src="/images/nexl_logo.svg" alt="go to home" />
        </Box>
      </Box>
    </Box>
  );
};
